// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg fill=%27gray%27 height=%2718%27 viewBox=%270 0 20 20%27 width=%2718%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M5.516 7.548a.625.625 0 0 1 .884 0L10 11.149l3.6-3.6a.625.625 0 1 1 .884.884l-4.042 4.042a.625.625 0 0 1-.884 0L5.516 8.432a.625.625 0 0 1 0-.884z%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FaqStyle_statsBadge__gWT-Y {
  background-color: #e3f2fd;
  color: #1976d2;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  margin-left: 8px;
}

.FaqStyle_moveBtn__p1TfO,
.FaqStyle_cloneBtn__LRxpX,
.FaqStyle_previewBtn__NO9mh {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 4px;
  margin-left: 4px;
  color: #666;
  transition: all 0.2s;
}

.FaqStyle_moveBtn__p1TfO:hover:not(:disabled),
.FaqStyle_cloneBtn__LRxpX:hover,
.FaqStyle_previewBtn__NO9mh:hover {
  background-color: #e0e0e0;
  color: #333;
}

.FaqStyle_moveBtn__p1TfO:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.FaqStyle_previewModal__JFkiU {
  max-width: 600px;
  width: 90%;
}

.FaqStyle_previewContent__v4eJ9 {
  max-height: 500px;
  overflow-y: auto;
  padding: 16px;
  background-color: #f9f9f9;
  border-radius: 8px;
  margin: 16px 0;
}

.FaqStyle_sectionTitle__Oti1e {
  font-weight: 600;
  margin-bottom: 10px;
  color: #333;
  font-size: 13px;
}

.FaqStyle_editBtn__v2SrH {
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  margin-left: 8px;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s;
}

.FaqStyle_editBtn__v2SrH:hover {
  background-color: #e0e0e0;
  color: #333;
}

.FaqStyle_statementWrapper__CdHRL {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 10px;
}

.FaqStyle_editStatementBtn__4li0W {
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  padding: 2px 4px;
  border-radius: 3px;
  transition: all 0.2s;
  flex-shrink: 0;
}

.FaqStyle_editStatementBtn__4li0W:hover {
  background-color: #e0e0e0;
  color: #333;
}

.FaqStyle_answerItem__sT9\\+5 {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  padding: 8px;
  border-bottom: 1px solid #eee;
}

.FaqStyle_answerContent__roI-j {
  flex: 1 1;
}

.FaqStyle_answerDescription__nAeY3 {
  margin-top: 5px;
  font-size: 13px;
  color: #666;
  line-height: 1.4;
}

.FaqStyle_answerDescription__nAeY3 p {
  margin: 0;
}

.FaqStyle_editAnswerBtn__jaCkW {
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 4px;
  transition: all 0.2s;
  flex-shrink: 0;
}

.FaqStyle_editAnswerBtn__jaCkW:hover {
  background-color: #e0e0e0;
  color: #333;
}

.FaqStyle_rootButtonContainer__mOaKU {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  width: 100%;
}

.FaqStyle_helperText__9bRGW {
  font-size: 14px;
  color: var(--subheading);
  display: flex;
  align-items: center;
  gap: 4px;
  font-style: italic;
}

.FaqStyle_statementButtonContainer__75WTi {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
}

.FaqStyle_helperTextSmall__AIAmE {
  font-size: 11px;
  color: #888;
  display: flex;
  align-items: center;
  gap: 8px;
  font-style: italic;
  margin-left: 4px;
  justify-content: center;
}

.FaqStyle_faqLeft__qU8QL {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.FaqStyle_missingAnswer__jLXPj {
  border: 2px solid red !important;
  border-radius: 4px;
}

/* To this: */
.FaqStyle_missingChildren__uoNKI {
  border: 2px solid red !important;
  border-radius: 4px;
}

/* .rootstyle {
  outline: none;
  background-color: var(--white-color);
  font-size: 16px;
  color: var(--seconadry-color);
  cursor: pointer;
  border: none;
} */

.FaqStyle_rootstyle__BcRCf {
  background-color: transparent;
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: 16px;
  color: var(--seconadry-color);
  cursor: pointer;
}
.FaqStyle_faqLeft__qU8QL .FaqStyle_rootstyle__BcRCf {
  text-align: center;
}
.FaqStyle_priview_wrapper__3FK9u {
  background-color: var(--white-color);
  width: 42%;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  height: 500px;
}
.FaqStyle_priview_wrapper__3FK9u h4 {
  font-size: 16px;
  font-weight: 500;
  font-style: italic;
  color: var(--dark-color);
  text-align: center;
  margin: 0px;
}
.FaqStyle_faq_outter__6-H-r {
  margin-left: 20px;
  border-left: 1px solid #ccc;
  padding-left: 10px;
}
.FaqStyle_addBtns_wrapper__3s9D2 {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 20px;
  margin-top: 10px;
  flex-wrap: wrap;
}
.FaqStyle_addBtns__RFYLK {
  outline: none;
  padding: 10px 16px;
  border: none;
  background-color: var(--seconadry-color);
  cursor: pointer;
  font-size: 15px;
  color: white;
  border-radius: 6px;
}
.FaqStyle_ansBtns__PpYii {
  background-color: transparent;
  border: 1px solid var(--seconadry-color);
  color: var(--seconadry-color);
}
.FaqStyle_saveFaqBtn__IG4jQ {
  margin-top: 30px;
}
.FaqStyle_back-button__1vhnE {
  display: flex;
  align-items: center;
  gap: 5px;
  outline: none;
  border: none;
  color: var(--dark-color);
  font-size: 16px;
  background-color: transparent;
  margin: 10px 0px 20px 0px;
}
.FaqStyle_node-value__AEmFC {
  margin-top: 10px;
  padding-left: 8px;
}
.FaqStyle_choices-container__aq4Xa {
  margin: 10px 0px 0px 0px;
  /* background: #dddddd; */
  border-radius: 5px;
  padding: 8px;
}
.FaqStyle_choice__76ESQ {
  outline: none;
  border: none;
  font-size: 14px;
  text-align: left;
  background: transparent;
  cursor: pointer;
}
/* .preview_contant{
    background-color: var(--seconadry-ic-bg);
    height: auto;
} */
.FaqStyle_chat-body__wqaBG {
  background-color: #dddddd;
  margin-top: 40px;
  padding: 10px;
  border-radius: 6px;
}
.FaqStyle_rootButtons__Gj3en {
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  width: 100%;
  gap: 25px;
  cursor: pointer;
  flex-direction: column;
}
.FaqStyle_loadJson__VRc6s {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
}
@media (max-width: 768px) {
  .FaqStyle_faq_outerWrap__gqrS\\+ {
    display: block;
  }
  .FaqStyle_faqLeft__qU8QL {
    width: 100%;
  }
  .FaqStyle_priview_wrapper__3FK9u {
    width: 100%;
  }
  .FaqStyle_loadJson__VRc6s {
    flex-direction: column;
  }
  .FaqStyle_statementButtonContainer__75WTi{
    width: 100%;
  }
}
.FaqStyle_cardHeader__jm7hO {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.FaqStyle_badge__K6Hl9 {
  padding: 2px 8px;
  font-size: 12px;
  border-radius: 6px;
  color: #fff;
}
.FaqStyle_badge__K6Hl9.FaqStyle_standard__UcUQE {
  background: #0073bb;
}
.FaqStyle_badge__K6Hl9.FaqStyle_input__3ltxn {
  background: #d35400;
}

.FaqStyle_statement__Z6Xev {
  font-size: 13px;
  color: #555;
  margin: 6px 0;
}

.FaqStyle_answersSection__Q7WMh {
  margin: 8px 0;
}

.FaqStyle_answerItem__sT9\\+5 {
  display: flex;
  justify-content: space-between;
  background: #e4ecff;

  padding: 20px 14px;
  border-radius: 4px;
  margin: 10px 0;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
}
.FaqStyle_answerItem__sT9\\+5 strong {
  font-weight: 500;
  color: #111827;
  margin-right: 4px;
  background-color: #f2f6ff;
  border: 1px solid #2563eb;
  padding: 8px 12px;
  border-radius: 8px;
  max-width: 75%;
  word-wrap: break-word;
  font-size: 16px;
}
.FaqStyle_actionRow__SEt42 {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 20px;
}

.FaqStyle_actionRow__SEt42 .FaqStyle_actionBtn__oLuUD {
  flex: 1 1;
  min-width: 0;
  box-sizing: border-box;
}

.FaqStyle_actionBtn__oLuUD {
  background: #f1f1f1;
  border: none;
  padding: 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}
.FaqStyle_addQst__PKn-K {
  background-color: #c5ffc7;
  color: #07740b;
}
.FaqStyle_addStat__cruSy {
  background-color: #c9e7ff;
  color: #2196f3;
}
.FaqStyle_addAns__pSNu6 {
  background-color: #ffe5bd;
  color: #ff9800;
}
.FaqStyle_addRemo__hphdo {
  background-color: #ffdcd9 !important;
  color: #f44336 !important ;
}
.FaqStyle_reetu__lijCX {
  color: red;
}
/* .actionBtn:hover {
  background: #e0e0e0;
} */

.FaqStyle_removeBtn__Di5ii {
  background: #ff4d4d;
  color: white;
  cursor: pointer;
}
.FaqStyle_closeBtn__cRwfY {
  border-radius: 50%;
  background: #ff4d4d;
  color: white;
  width: 28px;
  height: 28px;
  font-size: 16px;
  outline: none;
  border: none;
  cursor: pointer;
}
.FaqStyle_removeAllBtn__jx9cB {
  outline: none;
  border: none;
  background-color: transparent;
  border-bottom: 1px solid blueviolet;
  color: blueviolet;
  cursor: pointer;
  font-size: 14px;
}

.FaqStyle_faq_outerWrap__gqrS\\+ {
  display: flex;
  justify-content: space-between;
  width: 100%;
  /* padding: 16px; */
  background: #f8faff;
  align-items: flex-end;
  border-radius: 8px;
  /* box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px; */
  background-color: transparent;
  /* border: 1px solid #ccc; */
  gap: 16px;
  flex-direction: column-reverse;
}
/* .faqLeft .rootstyle:hover {
  border-bottom: 1px solid var(--seconadry-color);
} */
.FaqStyle_card__V6kn1 {
  background: var(--white-color);
  border: 1px solid #e2e2e2;
  border-radius: 6px;
  padding: 16px;
  box-shadow: none;
  transition: border-color 0.2s ease;
  width: 100%;
  margin-bottom: 20px;
  box-shadow: var(--shadow-md);
}

.FaqStyle_cardHeader__jm7hO {
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 16px;
}

.FaqStyle_collapseBtn__sZ8\\+- {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  margin-right: 8px;
}

.FaqStyle_questionText__5gEno {
  flex-grow: 1;
  text-align: left;
  font-weight: 600;
}

.FaqStyle_badge__K6Hl9 {
  font-size: 12px;
  padding: 3px 8px;
  border-radius: 4px;
  margin-left: 10px;
  color: white;
}

.FaqStyle_multiple__NX-J3 {
  background-color: #4caf50;
}

.FaqStyle_multiplechoice__Tkdqq {
  background-color: #4caf50;
}

.FaqStyle_userinput__i1vPG {
  background-color: #2196f3;
}

.FaqStyle_statement__Z6Xev {
  margin: 8px 0;
  font-style: italic;
  color: #444;
}

.FaqStyle_answersSection__Q7WMh {
  margin: 8px 0;
  padding-left: 15px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.FaqStyle_subQuestions__dGa9P {
  margin-top: 10px;
  /* padding-left: 20px; */
}

.FaqStyle_jsonView__G6AFn {
  background: #111;
  color: #0f0;
  font-family: monospace;
  padding: 12px;
  border-radius: 6px;
  max-height: 80vh;
  overflow-y: auto;
  width: 100%;
  text-align: left;
}
.FaqStyle_toggleButtons__7ibMO {
  display: flex;
  align-items: center;
  gap: 10px;
}

.FaqStyle_toggleButtons__7ibMO button {
  padding: 6px 12px;
  /* background: #673ab7; */
  background-color: #2b2b2b;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

/* Add to your FaqStyle.module.css */

/* .addButtonContainer {
  position: relative;
  display: inline-block;
} */

.FaqStyle_modalOverlay__7iMu5 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.FaqStyle_modal__AupJ7 {
  background: white;
  padding: 25px;
  border-radius: 12px;
  width: 420px;
  max-width: 90vw;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  animation: FaqStyle_modalAppear__k7YkK 0.3s ease-out;
}

@keyframes FaqStyle_modalAppear__k7YkK {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.FaqStyle_modalTitle__HkK4b {
  margin-top: 0;
  margin-bottom: 20px;
  font-size: 1.4rem;
  color: #333;
  text-align: center;
}

.FaqStyle_typeOptions__AZ6gp {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin: 20px 0;
}

.FaqStyle_typeOption__GHQjF {
  display: flex;
  align-items: flex-start;
  padding: 18px;
  border-radius: 10px;
  border: 2px solid #eaeaea;
  cursor: pointer;
  transition: all 0.2s ease;
}

.FaqStyle_typeOption__GHQjF:hover {
  border-color: #c5d5ff;
  background-color: #f8faff;
}

.FaqStyle_typeOptionSelected__H4cBs {
  border-color: #4a86e8 !important;
  background-color: #f0f5ff !important;
}

.FaqStyle_typeRadio__NIX4G {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
  margin-right: 15px;
  flex-shrink: 0;
  transition: border-color 0.2s;
}

.FaqStyle_typeOptionSelected__H4cBs .FaqStyle_typeRadio__NIX4G {
  border-color: #4a86e8;
}

.FaqStyle_typeRadioSelected__91oIp {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #4a86e8;
}

.FaqStyle_typeContent__GPANn {
  flex: 1 1;
}

.FaqStyle_typeContent__GPANn strong {
  display: block;
  margin-bottom: 5px;
  font-size: 1.1rem;
  color: #333;
}

.FaqStyle_typeContent__GPANn p {
  margin: 0;
  font-size: 0.9rem;
  color: #666;
  line-height: 1.4;
}

.FaqStyle_modalActions__x3PfY {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  gap: 12px;
}

.FaqStyle_modalCancel__vUvMQ,
.FaqStyle_modalConfirm__HOLt2 {
  padding: 10px 22px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  font-size: 0.95rem;
  transition: all 0.2s ease;
}

.FaqStyle_modalCancel__vUvMQ {
  background-color: #f0f0f0;
  color: #555;
}

.FaqStyle_modalCancel__vUvMQ:hover {
  background-color: #e0e0e0;
}

.FaqStyle_modalConfirm__HOLt2 {
  background-color: #4a86e8;
  color: white;
}

.FaqStyle_modalConfirm__HOLt2:hover {
  background-color: #3a76d8;
}
.FaqStyle_inputTypeSection__k03Tg {
  display: flex;
  gap: 10px;
  margin-top: 10px;
  align-items: center;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
}
.FaqStyle_inputTypeSection__k03Tg label {
  text-wrap: nowrap;
}
.FaqStyle_input_selectors__Pxt7f {
  width: 100%;
  padding: 10px 14px;
  font-size: 14px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #f4f4f4;
  transition:
    border 0.2s ease,
    background-color 0.2s ease;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 0.8rem center;
  background-size: 1rem;
}

/* Add to your existing CSS */
.FaqStyle_editStatementBtn__4li0W {
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  margin-left: 8px;
  padding: 2px 5px;
}

.FaqStyle_addStatementBtn__SP-hU {
  background-color: #f0f0f0;
  border: 1px dashed #ccc;
  border-radius: 4px;
  color: #666;
  cursor: pointer;
  font-size: 12px;
  margin-top: 5px;
  padding: 3px 8px;
}

.FaqStyle_addStatementBtn__SP-hU:hover {
  background-color: #e0e0e0;
}

/* Dropdown Options Styles */
.FaqStyle_optionsSection__XTzIw {
  margin-top: 1rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}
.FaqStyle_optionsButton__6iHrW {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background-color: #4d6bdf;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 0.6rem 1rem;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.FaqStyle_optionsButton__6iHrW:hover {
  background-color: #3e57c5;
}

.FaqStyle_optionsButton__6iHrW:active {
  transform: scale(0.97);
}

.FaqStyle_icon__VWw96 {
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.FaqStyle_optionsPreview__QRNhu {
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  gap: 10px;
}
.FaqStyle_optionsPreview__QRNhu strong {
  color: var(--seconadry-color);
  padding: 0px;
  background: transparent;
  font-style: italic;
}
.FaqStyle_optionsList__hhTUM {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
  margin-top: 0.3rem;
}

.FaqStyle_optionTag__0lfwk {
  background: #e9ecef;
  padding: 0.2rem 0.5rem;
  border-radius: 12px;
  font-size: 0.8rem;
  border: 1px solid #dee2e6;
}

.FaqStyle_optionsTextarea__6J9Dr {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-family: inherit;
  resize: vertical;
}

.FaqStyle_optionsExample__-kJnw {
  margin-top: 0.5rem;
  font-size: 0.85rem;
  color: #6c757d;
  font-style: italic;
}

/* Radio and Checkbox Options Styles */
.FaqStyle_radioOptions__MFrix,
.FaqStyle_checkboxOptions__Pm-Oh {
  margin-top: 0.5rem;
}

.FaqStyle_radioOption__u9yu6,
.FaqStyle_checkboxOption__NF3\\+n {
  display: flex;
  align-items: center;
  margin-bottom: 0.3rem;
  padding: 0.3rem;
  background: #f8f9fa;
  border-radius: 4px;
}

.FaqStyle_radioOption__u9yu6 input[type="radio"],
.FaqStyle_checkboxOption__NF3\\+n input[type="checkbox"] {
  margin-right: 0.5rem;
}

.FaqStyle_radioOption__u9yu6 label,
.FaqStyle_checkboxOption__NF3\\+n label {
  margin: 0;
  cursor: pointer;
}

/* Options Management Styles */
.FaqStyle_optionsSection__XTzIw {
  margin-top: 1rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.FaqStyle_optionsHeader__pmK9t {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.FaqStyle_optionsButton__6iHrW {
  background: #007bff;
  color: white;
  border: none;
  padding: 0.4rem 0.8rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.85rem;
}

.FaqStyle_optionsButton__6iHrW:hover {
  background: #0056b3;
}
.FaqStyle_optionsList__hhTUM {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
  margin-top: 0.3rem;
}

.FaqStyle_optionTag__0lfwk {
  background: #e9ecef;
  padding: 0.2rem 0.5rem;
  border-radius: 12px;
  font-size: 0.8rem;
  border: 1px solid #dee2e6;
}

.FaqStyle_optionsTextarea__6J9Dr {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-family: inherit;
  resize: vertical;
}

.FaqStyle_optionsExample__-kJnw {
  margin-top: 0.5rem;
  font-size: 0.85rem;
  color: #6c757d;
  font-style: italic;
}
.FaqStyle_fieldProperties__M4KYW {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  background-color: #e6edff;
  border: 1px solid #a3bdff;
  padding: 1rem;
  border-radius: 10px;
  margin-top: 10px;
}
.FaqStyle_toggleInput__tJt-B {
  display: flex;
  gap: 10px;
  align-items: center;
}
.FaqStyle_toggleInput__tJt-B label {
  white-space: nowrap;
  font-size: 15px;
  color: var(--dark-color);
}
.FaqStyle_toggleHelp__efV2s {
  font-size: 15px;
  font-style: italic;
  color: var(--text-color);
  padding-top: 15px;
}
.FaqStyle_rangeInputs__ScnYV {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 1rem;
  width: 100%;
}

.FaqStyle_rangeInputs__ScnYV > div {
  flex: 1 1 30%;
  min-width: 180px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.FaqStyle_rangeInputs__ScnYV label {
  font-weight: 500;
  font-size: 15px;
  color: var(--dark-color);
}

.FaqStyle_textInput__XwGb9 {
  width: 100%;
  padding: 0.6rem 0.8rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  background-color: #fff;
  color: #333;
  font-size: 0.95rem;
  outline: none;
  transition: all 0.2s ease;
}

.FaqStyle_textInput__XwGb9:focus {
  border-color: #4d6bdf;
  box-shadow: 0 0 0 2px rgba(77, 107, 223, 0.2);
}
/* ---------- Input Type Section ---------- */
.FaqStyle_inputTypeSection__k03Tg label {
  font-weight: 500;
  color: var(--dark-color);
  font-size: 15px;
  font-weight: 500;
}

.FaqStyle_input_selectors__Pxt7f {
  padding: 0.6rem 0.8rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  background-color: #fff;
  color: var(--dark-color);
  font-size: 0.95rem;
  outline: none;
  transition: all 0.2s ease;
}

.FaqStyle_input_selectors__Pxt7f:hover {
  border-color: #4d6bdf;
}

.FaqStyle_input_selectors__Pxt7f:focus {
  border-color: #4d6bdf;
  box-shadow: 0 0 0 2px rgba(77, 107, 223, 0.2);
}

/* ---------- Row Layout for Input + Checkbox ---------- */
.FaqStyle_fieldRow__AswJm {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap; /* Ensures it doesn’t overflow on smaller screens */
}

/* ---------- Placeholder Input ---------- */
.FaqStyle_fieldInput__z-H-E {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 1; /* makes input expand nicely */
}

.FaqStyle_fieldInput__z-H-E label {
  font-weight: 500;
  color: var(--dark-color);
  font-size: 15px;
  white-space: nowrap;
}

.FaqStyle_textInput__XwGb9 {
  flex: 1 1;
  padding: 0.6rem 0.8rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  background-color: #fff;
  color: #333;
  font-size: 0.95rem;
  outline: none;
  transition: all 0.2s ease;
}

.FaqStyle_textInput__XwGb9:focus {
  border-color: #4d6bdf;
  box-shadow: 0 0 0 2px rgba(77, 107, 223, 0.2);
}

/* ---------- Required Checkbox ---------- */
.FaqStyle_fieldCheckbox__UJn1H {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  color: #333;
  white-space: nowrap;
}

.FaqStyle_fieldCheckbox__UJn1H label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
  cursor: pointer;
}

.FaqStyle_fieldCheckbox__UJn1H input[type="checkbox"] {
  accent-color: #4d6bdf;
  width: 18px;
  height: 18px;
}

/* ---------- Responsive ---------- */
@media (max-width: 600px) {
  .FaqStyle_fieldRow__AswJm {
    flex-direction: column;
    align-items: flex-start;
  }

  .FaqStyle_fieldInput__z-H-E,
  .FaqStyle_fieldCheckbox__UJn1H {
    width: 100%;
  }
  .FaqStyle_rangeInputs__ScnYV {
    flex-direction: column;
    gap: 0.8rem;
  }

  .FaqStyle_rangeInputs__ScnYV > div {
    width: 100%;
    min-width: unset;
  }
}
@media (max-width: 1086px) and (min-width: 768px) {
  .FaqStyle_actionRow__SEt42 .FaqStyle_actionBtn__oLuUD {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 10px); /* 2 per row with spacing */
  }
}

@media (max-width: 1086px) and (min-width: 468px) {
  .FaqStyle_actionRow__SEt42 .FaqStyle_actionBtn__oLuUD {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 10px);
  }
  .FaqStyle_rootButtons__Gj3en {
    flex-direction: column;
  }
}

@media (max-width: 467px) {
  .FaqStyle_actionRow__SEt42 .FaqStyle_actionBtn__oLuUD {
    flex: 1 1 100%;
  }
  .FaqStyle_rootButtons__Gj3en {
    flex-direction: column;
  }
  .FaqStyle_card__V6kn1 {
    padding: 16px;
  }
  .FaqStyle_answerItem__sT9\\+5 {
    padding: 10px;
  }
  .FaqStyle_answerItem__sT9\\+5 strong {
    background-color: transparent;
    color: #007bff;
    padding: 0px;
    border: none;
  }

  .FaqStyle_answersSection__Q7WMh {
    padding-left: 0px;
  }
  .FaqStyle_optionsSection__XTzIw {
    border: none;
    border-top: 2px solid #e9ecef;
    padding: 0rem;
    padding-top: 10px;
    border-radius: 0px;
    background-color: transparent;
  }
  .FaqStyle_optionsHeader__pmK9t {
    align-items: flex-start;
  }
  .FaqStyle_fieldCheckbox__UJn1H {
    width: auto;
  }
  /* .cardHeader {
    flex-direction: column;
  } */
  .FaqStyle_fieldRow__AswJm {
    align-items: flex-end;
  }
  .FaqStyle_fieldInput__z-H-E {
    flex-direction: column;
    display: flex;
    align-items: flex-start;
  }
  .FaqStyle_inputTypeSection__k03Tg {
    flex-direction: column;
    align-items: flex-start;
    border: none;
    padding: 0;
  }
  .FaqStyle_fieldProperties__M4KYW {
    border: none;
    border-top: 2px solid #e0e4eb;
    border-radius: 0px;
    padding: 0px;
    background: transparent;
  }
  .FaqStyle_rangeInputs__ScnYV {
    flex-direction: column;
    gap: 0.8rem;
  }

  .FaqStyle_rangeInputs__ScnYV > div {
    flex-direction: column;
    align-items: flex-start;
  }
  .FaqStyle_toggleInput__tJt-B {
    flex-direction: column;
    align-items: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/app_components/FaqStyle.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;;AAEA;;;EAGE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;;;;;;;GAOG;;AAEH;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,UAAU;EACV,qDAAqD;EACrD,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;EACxC,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,wCAAwC;EACxC,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;AACA;;;GAGG;AACH;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,WAAW;EACX,SAAS;EACT,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACb;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;AACF;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;;EAEnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;AACA;EACE,UAAU;AACZ;AACA;;GAEG;;AAEH;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,mCAAmC;EACnC,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,iDAAiD;EACjD,6BAA6B;EAC7B,4BAA4B;EAC5B,SAAS;EACT,8BAA8B;AAChC;AACA;;GAEG;AACH;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,kCAAkC;EAClC,WAAW;EACX,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,oCAAoC;;AAEpC;;;GAGG;;AAEH;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,0CAA0C;EAC1C,oDAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB;;8BAE4B;EAC5B,gBAAgB;EAChB,yDAAoT;EACpT,4BAA4B;EAC5B,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,SAAS;EACT,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,2BAA2B;EAC3B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;AACA,6CAA6C;AAC7C;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe,EAAE,mDAAmD;AACtE;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO,EAAE,8BAA8B;AACzC;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA,qCAAqC;AACrC;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;;IAEE,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;AACA;EACE;IACE,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B,EAAE,2BAA2B;EACzD;AACF;;AAEA;EACE;IACE,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;EAC5B;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,6BAA6B;IAC7B,cAAc;IACd,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,6BAA6B;IAC7B,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;EAC/B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,WAAW;EACb;EACA;;KAEG;EACH;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;IACtB,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,UAAU;EACZ;EACA;IACE,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF","sourcesContent":[".statsBadge {\n  background-color: #e3f2fd;\n  color: #1976d2;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 500;\n  margin-left: 8px;\n}\n\n.moveBtn,\n.cloneBtn,\n.previewBtn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px 6px;\n  border-radius: 4px;\n  margin-left: 4px;\n  color: #666;\n  transition: all 0.2s;\n}\n\n.moveBtn:hover:not(:disabled),\n.cloneBtn:hover,\n.previewBtn:hover {\n  background-color: #e0e0e0;\n  color: #333;\n}\n\n.moveBtn:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n.previewModal {\n  max-width: 600px;\n  width: 90%;\n}\n\n.previewContent {\n  max-height: 500px;\n  overflow-y: auto;\n  padding: 16px;\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  margin: 16px 0;\n}\n\n.sectionTitle {\n  font-weight: 600;\n  margin-bottom: 10px;\n  color: #333;\n  font-size: 13px;\n}\n\n.editBtn {\n  background: none;\n  border: none;\n  color: #666;\n  cursor: pointer;\n  margin-left: 8px;\n  padding: 4px;\n  border-radius: 4px;\n  transition: all 0.2s;\n}\n\n.editBtn:hover {\n  background-color: #e0e0e0;\n  color: #333;\n}\n\n.statementWrapper {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.editStatementBtn {\n  background: none;\n  border: none;\n  color: #666;\n  cursor: pointer;\n  padding: 2px 4px;\n  border-radius: 3px;\n  transition: all 0.2s;\n  flex-shrink: 0;\n}\n\n.editStatementBtn:hover {\n  background-color: #e0e0e0;\n  color: #333;\n}\n\n.answerItem {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 8px;\n  border-bottom: 1px solid #eee;\n}\n\n.answerContent {\n  flex: 1;\n}\n\n.answerDescription {\n  margin-top: 5px;\n  font-size: 13px;\n  color: #666;\n  line-height: 1.4;\n}\n\n.answerDescription p {\n  margin: 0;\n}\n\n.editAnswerBtn {\n  background: none;\n  border: none;\n  color: #666;\n  cursor: pointer;\n  padding: 4px 6px;\n  border-radius: 4px;\n  transition: all 0.2s;\n  flex-shrink: 0;\n}\n\n.editAnswerBtn:hover {\n  background-color: #e0e0e0;\n  color: #333;\n}\n\n.rootButtonContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-items: center;\n  width: 100%;\n}\n\n.helperText {\n  font-size: 14px;\n  color: var(--subheading);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-style: italic;\n}\n\n.statementButtonContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  width: 100%;\n}\n\n.helperTextSmall {\n  font-size: 11px;\n  color: #888;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-style: italic;\n  margin-left: 4px;\n  justify-content: center;\n}\n\n.faqLeft {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n\n.missingAnswer {\n  border: 2px solid red !important;\n  border-radius: 4px;\n}\n\n/* To this: */\n.missingChildren {\n  border: 2px solid red !important;\n  border-radius: 4px;\n}\n\n/* .rootstyle {\n  outline: none;\n  background-color: var(--white-color);\n  font-size: 16px;\n  color: var(--seconadry-color);\n  cursor: pointer;\n  border: none;\n} */\n\n.rootstyle {\n  background-color: transparent;\n  border: 1px solid #ccc;\n  padding: 20px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  font-size: 16px;\n  color: var(--seconadry-color);\n  cursor: pointer;\n}\n.faqLeft .rootstyle {\n  text-align: center;\n}\n.priview_wrapper {\n  background-color: var(--white-color);\n  width: 42%;\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n  height: 500px;\n}\n.priview_wrapper h4 {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: italic;\n  color: var(--dark-color);\n  text-align: center;\n  margin: 0px;\n}\n.faq_outter {\n  margin-left: 20px;\n  border-left: 1px solid #ccc;\n  padding-left: 10px;\n}\n.addBtns_wrapper {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin-bottom: 20px;\n  margin-top: 10px;\n  flex-wrap: wrap;\n}\n.addBtns {\n  outline: none;\n  padding: 10px 16px;\n  border: none;\n  background-color: var(--seconadry-color);\n  cursor: pointer;\n  font-size: 15px;\n  color: white;\n  border-radius: 6px;\n}\n.ansBtns {\n  background-color: transparent;\n  border: 1px solid var(--seconadry-color);\n  color: var(--seconadry-color);\n}\n.saveFaqBtn {\n  margin-top: 30px;\n}\n.back-button {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  outline: none;\n  border: none;\n  color: var(--dark-color);\n  font-size: 16px;\n  background-color: transparent;\n  margin: 10px 0px 20px 0px;\n}\n.node-value {\n  margin-top: 10px;\n  padding-left: 8px;\n}\n.choices-container {\n  margin: 10px 0px 0px 0px;\n  /* background: #dddddd; */\n  border-radius: 5px;\n  padding: 8px;\n}\n.choice {\n  outline: none;\n  border: none;\n  font-size: 14px;\n  text-align: left;\n  background: transparent;\n  cursor: pointer;\n}\n/* .preview_contant{\n    background-color: var(--seconadry-ic-bg);\n    height: auto;\n} */\n.chat-body {\n  background-color: #dddddd;\n  margin-top: 40px;\n  padding: 10px;\n  border-radius: 6px;\n}\n.rootButtons {\n  display: flex;\n  align-items: center;\n  /* justify-content: space-between; */\n  width: 100%;\n  gap: 25px;\n  cursor: pointer;\n  flex-direction: column;\n}\n.loadJson {\n  display: flex;\n  justify-content: space-between;\n  gap: 20px;\n  width: 100%;\n}\n@media (max-width: 768px) {\n  .faq_outerWrap {\n    display: block;\n  }\n  .faqLeft {\n    width: 100%;\n  }\n  .priview_wrapper {\n    width: 100%;\n  }\n  .loadJson {\n    flex-direction: column;\n  }\n  .statementButtonContainer{\n    width: 100%;\n  }\n}\n.cardHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.badge {\n  padding: 2px 8px;\n  font-size: 12px;\n  border-radius: 6px;\n  color: #fff;\n}\n.badge.standard {\n  background: #0073bb;\n}\n.badge.input {\n  background: #d35400;\n}\n\n.statement {\n  font-size: 13px;\n  color: #555;\n  margin: 6px 0;\n}\n\n.answersSection {\n  margin: 8px 0;\n}\n\n.answerItem {\n  display: flex;\n  justify-content: space-between;\n  background: #e4ecff;\n\n  padding: 20px 14px;\n  border-radius: 4px;\n  margin: 10px 0;\n  width: 100%;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 20px;\n}\n.answerItem strong {\n  font-weight: 500;\n  color: #111827;\n  margin-right: 4px;\n  background-color: #f2f6ff;\n  border: 1px solid #2563eb;\n  padding: 8px 12px;\n  border-radius: 8px;\n  max-width: 75%;\n  word-wrap: break-word;\n  font-size: 16px;\n}\n.actionRow {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.actionRow .actionBtn {\n  flex: 1;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.actionBtn {\n  background: #f1f1f1;\n  border: none;\n  padding: 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n}\n.addQst {\n  background-color: #c5ffc7;\n  color: #07740b;\n}\n.addStat {\n  background-color: #c9e7ff;\n  color: #2196f3;\n}\n.addAns {\n  background-color: #ffe5bd;\n  color: #ff9800;\n}\n.addRemo {\n  background-color: #ffdcd9 !important;\n  color: #f44336 !important ;\n}\n.reetu {\n  color: red;\n}\n/* .actionBtn:hover {\n  background: #e0e0e0;\n} */\n\n.removeBtn {\n  background: #ff4d4d;\n  color: white;\n  cursor: pointer;\n}\n.closeBtn {\n  border-radius: 50%;\n  background: #ff4d4d;\n  color: white;\n  width: 28px;\n  height: 28px;\n  font-size: 16px;\n  outline: none;\n  border: none;\n  cursor: pointer;\n}\n.removeAllBtn {\n  outline: none;\n  border: none;\n  background-color: transparent;\n  border-bottom: 1px solid blueviolet;\n  color: blueviolet;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.faq_outerWrap {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  /* padding: 16px; */\n  background: #f8faff;\n  align-items: flex-end;\n  border-radius: 8px;\n  /* box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px; */\n  background-color: transparent;\n  /* border: 1px solid #ccc; */\n  gap: 16px;\n  flex-direction: column-reverse;\n}\n/* .faqLeft .rootstyle:hover {\n  border-bottom: 1px solid var(--seconadry-color);\n} */\n.card {\n  background: var(--white-color);\n  border: 1px solid #e2e2e2;\n  border-radius: 6px;\n  padding: 16px;\n  box-shadow: none;\n  transition: border-color 0.2s ease;\n  width: 100%;\n  margin-bottom: 20px;\n  box-shadow: var(--shadow-md);\n}\n\n.cardHeader {\n  display: flex;\n  align-items: center;\n  font-weight: bold;\n  font-size: 16px;\n}\n\n.collapseBtn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  margin-right: 8px;\n}\n\n.questionText {\n  flex-grow: 1;\n  text-align: left;\n  font-weight: 600;\n}\n\n.badge {\n  font-size: 12px;\n  padding: 3px 8px;\n  border-radius: 4px;\n  margin-left: 10px;\n  color: white;\n}\n\n.multiple {\n  background-color: #4caf50;\n}\n\n.multiplechoice {\n  background-color: #4caf50;\n}\n\n.userinput {\n  background-color: #2196f3;\n}\n\n.statement {\n  margin: 8px 0;\n  font-style: italic;\n  color: #444;\n}\n\n.answersSection {\n  margin: 8px 0;\n  padding-left: 15px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n.subQuestions {\n  margin-top: 10px;\n  /* padding-left: 20px; */\n}\n\n.jsonView {\n  background: #111;\n  color: #0f0;\n  font-family: monospace;\n  padding: 12px;\n  border-radius: 6px;\n  max-height: 80vh;\n  overflow-y: auto;\n  width: 100%;\n  text-align: left;\n}\n.toggleButtons {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.toggleButtons button {\n  padding: 6px 12px;\n  /* background: #673ab7; */\n  background-color: #2b2b2b;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n/* Add to your FaqStyle.module.css */\n\n/* .addButtonContainer {\n  position: relative;\n  display: inline-block;\n} */\n\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal {\n  background: white;\n  padding: 25px;\n  border-radius: 12px;\n  width: 420px;\n  max-width: 90vw;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);\n  animation: modalAppear 0.3s ease-out;\n}\n\n@keyframes modalAppear {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.modalTitle {\n  margin-top: 0;\n  margin-bottom: 20px;\n  font-size: 1.4rem;\n  color: #333;\n  text-align: center;\n}\n\n.typeOptions {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  margin: 20px 0;\n}\n\n.typeOption {\n  display: flex;\n  align-items: flex-start;\n  padding: 18px;\n  border-radius: 10px;\n  border: 2px solid #eaeaea;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.typeOption:hover {\n  border-color: #c5d5ff;\n  background-color: #f8faff;\n}\n\n.typeOptionSelected {\n  border-color: #4a86e8 !important;\n  background-color: #f0f5ff !important;\n}\n\n.typeRadio {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  border: 2px solid #ccc;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 2px;\n  margin-right: 15px;\n  flex-shrink: 0;\n  transition: border-color 0.2s;\n}\n\n.typeOptionSelected .typeRadio {\n  border-color: #4a86e8;\n}\n\n.typeRadioSelected {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background-color: #4a86e8;\n}\n\n.typeContent {\n  flex: 1;\n}\n\n.typeContent strong {\n  display: block;\n  margin-bottom: 5px;\n  font-size: 1.1rem;\n  color: #333;\n}\n\n.typeContent p {\n  margin: 0;\n  font-size: 0.9rem;\n  color: #666;\n  line-height: 1.4;\n}\n\n.modalActions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 20px;\n  gap: 12px;\n}\n\n.modalCancel,\n.modalConfirm {\n  padding: 10px 22px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 0.95rem;\n  transition: all 0.2s ease;\n}\n\n.modalCancel {\n  background-color: #f0f0f0;\n  color: #555;\n}\n\n.modalCancel:hover {\n  background-color: #e0e0e0;\n}\n\n.modalConfirm {\n  background-color: #4a86e8;\n  color: white;\n}\n\n.modalConfirm:hover {\n  background-color: #3a76d8;\n}\n.inputTypeSection {\n  display: flex;\n  gap: 10px;\n  margin-top: 10px;\n  align-items: center;\n  padding: 20px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n}\n.inputTypeSection label {\n  text-wrap: nowrap;\n}\n.input_selectors {\n  width: 100%;\n  padding: 10px 14px;\n  font-size: 14px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background-color: #f4f4f4;\n  transition:\n    border 0.2s ease,\n    background-color 0.2s ease;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml;utf8,<svg fill='gray' height='18' viewBox='0 0 20 20' width='18' xmlns='http://www.w3.org/2000/svg'><path d='M5.516 7.548a.625.625 0 0 1 .884 0L10 11.149l3.6-3.6a.625.625 0 1 1 .884.884l-4.042 4.042a.625.625 0 0 1-.884 0L5.516 8.432a.625.625 0 0 1 0-.884z'/></svg>\");\n  background-repeat: no-repeat;\n  background-position: right 0.8rem center;\n  background-size: 1rem;\n}\n\n/* Add to your existing CSS */\n.editStatementBtn {\n  background: none;\n  border: none;\n  color: #666;\n  cursor: pointer;\n  margin-left: 8px;\n  padding: 2px 5px;\n}\n\n.addStatementBtn {\n  background-color: #f0f0f0;\n  border: 1px dashed #ccc;\n  border-radius: 4px;\n  color: #666;\n  cursor: pointer;\n  font-size: 12px;\n  margin-top: 5px;\n  padding: 3px 8px;\n}\n\n.addStatementBtn:hover {\n  background-color: #e0e0e0;\n}\n\n/* Dropdown Options Styles */\n.optionsSection {\n  margin-top: 1rem;\n  padding: 1rem;\n  background: #f8f9fa;\n  border-radius: 6px;\n  border: 1px solid #e9ecef;\n}\n.optionsButton {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  background-color: #4d6bdf;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  padding: 0.6rem 1rem;\n  font-size: 0.95rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.optionsButton:hover {\n  background-color: #3e57c5;\n}\n\n.optionsButton:active {\n  transform: scale(0.97);\n}\n\n.icon {\n  font-size: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.optionsPreview {\n  margin-top: 0.5rem;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.optionsPreview strong {\n  color: var(--seconadry-color);\n  padding: 0px;\n  background: transparent;\n  font-style: italic;\n}\n.optionsList {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n  margin-top: 0.3rem;\n}\n\n.optionTag {\n  background: #e9ecef;\n  padding: 0.2rem 0.5rem;\n  border-radius: 12px;\n  font-size: 0.8rem;\n  border: 1px solid #dee2e6;\n}\n\n.optionsTextarea {\n  width: 100%;\n  padding: 0.5rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-family: inherit;\n  resize: vertical;\n}\n\n.optionsExample {\n  margin-top: 0.5rem;\n  font-size: 0.85rem;\n  color: #6c757d;\n  font-style: italic;\n}\n\n/* Radio and Checkbox Options Styles */\n.radioOptions,\n.checkboxOptions {\n  margin-top: 0.5rem;\n}\n\n.radioOption,\n.checkboxOption {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.3rem;\n  padding: 0.3rem;\n  background: #f8f9fa;\n  border-radius: 4px;\n}\n\n.radioOption input[type=\"radio\"],\n.checkboxOption input[type=\"checkbox\"] {\n  margin-right: 0.5rem;\n}\n\n.radioOption label,\n.checkboxOption label {\n  margin: 0;\n  cursor: pointer;\n}\n\n/* Options Management Styles */\n.optionsSection {\n  margin-top: 1rem;\n  padding: 1rem;\n  background: #f8f9fa;\n  border-radius: 6px;\n  border: 1px solid #e9ecef;\n}\n\n.optionsHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n\n.optionsButton {\n  background: #007bff;\n  color: white;\n  border: none;\n  padding: 0.4rem 0.8rem;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.85rem;\n}\n\n.optionsButton:hover {\n  background: #0056b3;\n}\n.optionsList {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n  margin-top: 0.3rem;\n}\n\n.optionTag {\n  background: #e9ecef;\n  padding: 0.2rem 0.5rem;\n  border-radius: 12px;\n  font-size: 0.8rem;\n  border: 1px solid #dee2e6;\n}\n\n.optionsTextarea {\n  width: 100%;\n  padding: 0.5rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-family: inherit;\n  resize: vertical;\n}\n\n.optionsExample {\n  margin-top: 0.5rem;\n  font-size: 0.85rem;\n  color: #6c757d;\n  font-style: italic;\n}\n.fieldProperties {\n  display: flex;\n  flex-direction: column;\n  gap: 1.2rem;\n  background-color: #e6edff;\n  border: 1px solid #a3bdff;\n  padding: 1rem;\n  border-radius: 10px;\n  margin-top: 10px;\n}\n.toggleInput {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n.toggleInput label {\n  white-space: nowrap;\n  font-size: 15px;\n  color: var(--dark-color);\n}\n.toggleHelp {\n  font-size: 15px;\n  font-style: italic;\n  color: var(--text-color);\n  padding-top: 15px;\n}\n.rangeInputs {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 1rem;\n  width: 100%;\n}\n\n.rangeInputs > div {\n  flex: 1 1 30%;\n  min-width: 180px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.rangeInputs label {\n  font-weight: 500;\n  font-size: 15px;\n  color: var(--dark-color);\n}\n\n.textInput {\n  width: 100%;\n  padding: 0.6rem 0.8rem;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  background-color: #fff;\n  color: #333;\n  font-size: 0.95rem;\n  outline: none;\n  transition: all 0.2s ease;\n}\n\n.textInput:focus {\n  border-color: #4d6bdf;\n  box-shadow: 0 0 0 2px rgba(77, 107, 223, 0.2);\n}\n/* ---------- Input Type Section ---------- */\n.inputTypeSection label {\n  font-weight: 500;\n  color: var(--dark-color);\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.input_selectors {\n  padding: 0.6rem 0.8rem;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  background-color: #fff;\n  color: var(--dark-color);\n  font-size: 0.95rem;\n  outline: none;\n  transition: all 0.2s ease;\n}\n\n.input_selectors:hover {\n  border-color: #4d6bdf;\n}\n\n.input_selectors:focus {\n  border-color: #4d6bdf;\n  box-shadow: 0 0 0 2px rgba(77, 107, 223, 0.2);\n}\n\n/* ---------- Row Layout for Input + Checkbox ---------- */\n.fieldRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  flex-wrap: wrap; /* Ensures it doesn’t overflow on smaller screens */\n}\n\n/* ---------- Placeholder Input ---------- */\n.fieldInput {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex: 1; /* makes input expand nicely */\n}\n\n.fieldInput label {\n  font-weight: 500;\n  color: var(--dark-color);\n  font-size: 15px;\n  white-space: nowrap;\n}\n\n.textInput {\n  flex: 1;\n  padding: 0.6rem 0.8rem;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  background-color: #fff;\n  color: #333;\n  font-size: 0.95rem;\n  outline: none;\n  transition: all 0.2s ease;\n}\n\n.textInput:focus {\n  border-color: #4d6bdf;\n  box-shadow: 0 0 0 2px rgba(77, 107, 223, 0.2);\n}\n\n/* ---------- Required Checkbox ---------- */\n.fieldCheckbox {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  color: #333;\n  white-space: nowrap;\n}\n\n.fieldCheckbox label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.fieldCheckbox input[type=\"checkbox\"] {\n  accent-color: #4d6bdf;\n  width: 18px;\n  height: 18px;\n}\n\n/* ---------- Responsive ---------- */\n@media (max-width: 600px) {\n  .fieldRow {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .fieldInput,\n  .fieldCheckbox {\n    width: 100%;\n  }\n  .rangeInputs {\n    flex-direction: column;\n    gap: 0.8rem;\n  }\n\n  .rangeInputs > div {\n    width: 100%;\n    min-width: unset;\n  }\n}\n@media (max-width: 1086px) and (min-width: 768px) {\n  .actionRow .actionBtn {\n    flex: 1 1 calc(50% - 10px); /* 2 per row with spacing */\n  }\n}\n\n@media (max-width: 1086px) and (min-width: 468px) {\n  .actionRow .actionBtn {\n    flex: 1 1 calc(50% - 10px);\n  }\n  .rootButtons {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 467px) {\n  .actionRow .actionBtn {\n    flex: 1 1 100%;\n  }\n  .rootButtons {\n    flex-direction: column;\n  }\n  .card {\n    padding: 16px;\n  }\n  .answerItem {\n    padding: 10px;\n  }\n  .answerItem strong {\n    background-color: transparent;\n    color: #007bff;\n    padding: 0px;\n    border: none;\n  }\n\n  .answersSection {\n    padding-left: 0px;\n  }\n  .optionsSection {\n    border: none;\n    border-top: 2px solid #e9ecef;\n    padding: 0rem;\n    padding-top: 10px;\n    border-radius: 0px;\n    background-color: transparent;\n  }\n  .optionsHeader {\n    align-items: flex-start;\n  }\n  .fieldCheckbox {\n    width: auto;\n  }\n  /* .cardHeader {\n    flex-direction: column;\n  } */\n  .fieldRow {\n    align-items: flex-end;\n  }\n  .fieldInput {\n    flex-direction: column;\n    display: flex;\n    align-items: flex-start;\n  }\n  .inputTypeSection {\n    flex-direction: column;\n    align-items: flex-start;\n    border: none;\n    padding: 0;\n  }\n  .fieldProperties {\n    border: none;\n    border-top: 2px solid #e0e4eb;\n    border-radius: 0px;\n    padding: 0px;\n    background: transparent;\n  }\n  .rangeInputs {\n    flex-direction: column;\n    gap: 0.8rem;\n  }\n\n  .rangeInputs > div {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .toggleInput {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statsBadge": `FaqStyle_statsBadge__gWT-Y`,
	"moveBtn": `FaqStyle_moveBtn__p1TfO`,
	"cloneBtn": `FaqStyle_cloneBtn__LRxpX`,
	"previewBtn": `FaqStyle_previewBtn__NO9mh`,
	"previewModal": `FaqStyle_previewModal__JFkiU`,
	"previewContent": `FaqStyle_previewContent__v4eJ9`,
	"sectionTitle": `FaqStyle_sectionTitle__Oti1e`,
	"editBtn": `FaqStyle_editBtn__v2SrH`,
	"statementWrapper": `FaqStyle_statementWrapper__CdHRL`,
	"editStatementBtn": `FaqStyle_editStatementBtn__4li0W`,
	"answerItem": `FaqStyle_answerItem__sT9+5`,
	"answerContent": `FaqStyle_answerContent__roI-j`,
	"answerDescription": `FaqStyle_answerDescription__nAeY3`,
	"editAnswerBtn": `FaqStyle_editAnswerBtn__jaCkW`,
	"rootButtonContainer": `FaqStyle_rootButtonContainer__mOaKU`,
	"helperText": `FaqStyle_helperText__9bRGW`,
	"statementButtonContainer": `FaqStyle_statementButtonContainer__75WTi`,
	"helperTextSmall": `FaqStyle_helperTextSmall__AIAmE`,
	"faqLeft": `FaqStyle_faqLeft__qU8QL`,
	"missingAnswer": `FaqStyle_missingAnswer__jLXPj`,
	"missingChildren": `FaqStyle_missingChildren__uoNKI`,
	"rootstyle": `FaqStyle_rootstyle__BcRCf`,
	"priview_wrapper": `FaqStyle_priview_wrapper__3FK9u`,
	"faq_outter": `FaqStyle_faq_outter__6-H-r`,
	"addBtns_wrapper": `FaqStyle_addBtns_wrapper__3s9D2`,
	"addBtns": `FaqStyle_addBtns__RFYLK`,
	"ansBtns": `FaqStyle_ansBtns__PpYii`,
	"saveFaqBtn": `FaqStyle_saveFaqBtn__IG4jQ`,
	"back-button": `FaqStyle_back-button__1vhnE`,
	"node-value": `FaqStyle_node-value__AEmFC`,
	"choices-container": `FaqStyle_choices-container__aq4Xa`,
	"choice": `FaqStyle_choice__76ESQ`,
	"chat-body": `FaqStyle_chat-body__wqaBG`,
	"rootButtons": `FaqStyle_rootButtons__Gj3en`,
	"loadJson": `FaqStyle_loadJson__VRc6s`,
	"faq_outerWrap": `FaqStyle_faq_outerWrap__gqrS+`,
	"cardHeader": `FaqStyle_cardHeader__jm7hO`,
	"badge": `FaqStyle_badge__K6Hl9`,
	"standard": `FaqStyle_standard__UcUQE`,
	"input": `FaqStyle_input__3ltxn`,
	"statement": `FaqStyle_statement__Z6Xev`,
	"answersSection": `FaqStyle_answersSection__Q7WMh`,
	"actionRow": `FaqStyle_actionRow__SEt42`,
	"actionBtn": `FaqStyle_actionBtn__oLuUD`,
	"addQst": `FaqStyle_addQst__PKn-K`,
	"addStat": `FaqStyle_addStat__cruSy`,
	"addAns": `FaqStyle_addAns__pSNu6`,
	"addRemo": `FaqStyle_addRemo__hphdo`,
	"reetu": `FaqStyle_reetu__lijCX`,
	"removeBtn": `FaqStyle_removeBtn__Di5ii`,
	"closeBtn": `FaqStyle_closeBtn__cRwfY`,
	"removeAllBtn": `FaqStyle_removeAllBtn__jx9cB`,
	"card": `FaqStyle_card__V6kn1`,
	"collapseBtn": `FaqStyle_collapseBtn__sZ8+-`,
	"questionText": `FaqStyle_questionText__5gEno`,
	"multiple": `FaqStyle_multiple__NX-J3`,
	"multiplechoice": `FaqStyle_multiplechoice__Tkdqq`,
	"userinput": `FaqStyle_userinput__i1vPG`,
	"subQuestions": `FaqStyle_subQuestions__dGa9P`,
	"jsonView": `FaqStyle_jsonView__G6AFn`,
	"toggleButtons": `FaqStyle_toggleButtons__7ibMO`,
	"modalOverlay": `FaqStyle_modalOverlay__7iMu5`,
	"modal": `FaqStyle_modal__AupJ7`,
	"modalAppear": `FaqStyle_modalAppear__k7YkK`,
	"modalTitle": `FaqStyle_modalTitle__HkK4b`,
	"typeOptions": `FaqStyle_typeOptions__AZ6gp`,
	"typeOption": `FaqStyle_typeOption__GHQjF`,
	"typeOptionSelected": `FaqStyle_typeOptionSelected__H4cBs`,
	"typeRadio": `FaqStyle_typeRadio__NIX4G`,
	"typeRadioSelected": `FaqStyle_typeRadioSelected__91oIp`,
	"typeContent": `FaqStyle_typeContent__GPANn`,
	"modalActions": `FaqStyle_modalActions__x3PfY`,
	"modalCancel": `FaqStyle_modalCancel__vUvMQ`,
	"modalConfirm": `FaqStyle_modalConfirm__HOLt2`,
	"inputTypeSection": `FaqStyle_inputTypeSection__k03Tg`,
	"input_selectors": `FaqStyle_input_selectors__Pxt7f`,
	"addStatementBtn": `FaqStyle_addStatementBtn__SP-hU`,
	"optionsSection": `FaqStyle_optionsSection__XTzIw`,
	"optionsButton": `FaqStyle_optionsButton__6iHrW`,
	"icon": `FaqStyle_icon__VWw96`,
	"optionsPreview": `FaqStyle_optionsPreview__QRNhu`,
	"optionsList": `FaqStyle_optionsList__hhTUM`,
	"optionTag": `FaqStyle_optionTag__0lfwk`,
	"optionsTextarea": `FaqStyle_optionsTextarea__6J9Dr`,
	"optionsExample": `FaqStyle_optionsExample__-kJnw`,
	"radioOptions": `FaqStyle_radioOptions__MFrix`,
	"checkboxOptions": `FaqStyle_checkboxOptions__Pm-Oh`,
	"radioOption": `FaqStyle_radioOption__u9yu6`,
	"checkboxOption": `FaqStyle_checkboxOption__NF3+n`,
	"optionsHeader": `FaqStyle_optionsHeader__pmK9t`,
	"fieldProperties": `FaqStyle_fieldProperties__M4KYW`,
	"toggleInput": `FaqStyle_toggleInput__tJt-B`,
	"toggleHelp": `FaqStyle_toggleHelp__efV2s`,
	"rangeInputs": `FaqStyle_rangeInputs__ScnYV`,
	"textInput": `FaqStyle_textInput__XwGb9`,
	"fieldRow": `FaqStyle_fieldRow__AswJm`,
	"fieldInput": `FaqStyle_fieldInput__z-H-E`,
	"fieldCheckbox": `FaqStyle_fieldCheckbox__UJn1H`
};
export default ___CSS_LOADER_EXPORT___;
